import {Navigate, Outlet, useLocation} from "react-router-dom";
import {useAuth} from "../hooks/useAuth";
import {ProgressSpinner} from "primereact/progressspinner";

const PrivateRoute = () => {
    const { accessToken,isLoading } = useAuth();


    const location = useLocation();
    // if (isLoading) return <AuthLoader/>;
    if (isLoading) return <div style={{height:'100vh',width:'100%',position:'fixed',top:0,left:0,zIndex:500000000000000,background:'white'}} className='flex align-items-center justify-content-center'>
        <ProgressSpinner />
    </div>;
    if (!accessToken) return <Navigate to="/auth/login" state={{ from: location }} replace />;

    return <Outlet />;
};

export default PrivateRoute;
